import { useRef, useState } from "react";
import { useHistory } from "react-router";
//MUI components
import { Edit3 } from "react-feather";
import { Button, Modal, TableCell, Tooltip, TableRow } from "@material-ui/core";
import { ArrowSquareIn } from "phosphor-react";
import { fdelete } from "../../../API/callsAPI";
import CustomTableBodyForAllTrackables from "../../Utilities/CustomTableForAllTrackables/CustomTableBodyForAllTrackables";
import DateAndTimeViewer from "../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import ImageViewer from "../../Utilities/ImageViewer/ImageViewer.component";
import MultipleDepartmentViewer from "../../Utilities/MultipleDepartmentViewer/MultipleDepartmentViewer";
import NoThumbnail from "../../Utilities/NoThumbnail.component";
import StatusDropDown from "../../Utilities/StatusDropDown/StatusDropDown.component";
import ReferenceFolderIcon from "../../Utilities/Svg/ReferenceFolderIcon";
import AssetListCharactersTags from "../AssetsListContents/AssetListCharactersTags.component";
import AssetListDepartmentsTags from "../AssetsListContents/AssetListDepartmentsTags.component";
import AssetsPageEditAssetModal from "../AssetsPageModal/AssetsPageEditAssetModal";
import useStyles from "./AssetsList.styles";

function AssetsList(props) {
  const ref = useRef(null);
  const classes = useStyles();
  const history = useHistory();
  const [showDepartments, setShowDepartments] = useState(false);

  return (
    <>
      <TableRow
        hover
        onClick={(event) => {
          if (event.ctrlKey) {
            window.open(
              `/${props.projectId}/assets/${props.data.id}/assetversions`,
            );
            sessionStorage.setItem("scrollpos", window.scrollY);
          } else {
            history.push(
              `/${props.projectId}/assets/${props.data.id}/assetversions`,
            );
            sessionStorage.setItem("scrollpos", window.scrollY);
          }
        }}
        style={{
          cursor: "pointer",

          display: "table",
          width: "100%",
          tableLayout: "fixed",
        }}
      >
        <TableCell
          component="th"
          scope="row"
          className={classes.listTextTwo}
          align="left"
        >
          <div style={{ display: "flex" }}>
            {props.data.thumbnail ? (
              <ImageViewer
                sliderState={props.isAssetTogglerOn ? 25 : 0}
                url={props.data.thumbnail}
              />
            ) : (
              <NoThumbnail sliderState={props.isAssetTogglerOn ? 25 : 0} />
            )}
            <p style={{ marginLeft: "10px" }}>{props.data.name}</p>
          </div>
        </TableCell>
        <TableCell
          className={classes.listText}
          align="center"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Tooltip title={props?.data?.description}>
            {props.data?.description ? (
              <span>{props.data?.description}</span>
            ) : (
              <span>--</span>
            )}
          </Tooltip>
        </TableCell>
        <TableCell className={classes.listText} align="center">
          <div className={classes.DepartmentDiv}>
            <AssetListCharactersTags content={props.data.type} />
          </div>
        </TableCell>
        <TableCell className={classes.listText}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "15px",
            }}
          >
            <StatusDropDown
              url={`trackables/asset/${props.data.id}/`}
              statusList={props?.statusList}
              currStatus={props?.data?.status}
              updateRefreshCounter={props.updateRefreshCounter}
            />
          </div>
        </TableCell>
        <TableCell className={classes.listText} align="center">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DateAndTimeViewer dateAndTime={props?.data?.updated_at} />
          </div>
        </TableCell>
        <TableCell className={classes.listText} align="center">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {props.data.allowed_dept.length !== 0 ? (
              <div style={{ display: "flex" }}>
                <AssetListDepartmentsTags
                  allowedDepartments={props.data.allowed_dept[0]}
                />
                {props.data.allowed_dept.length > 1 ? (
                  <div
                    ref={ref}
                    onMouseEnter={() => setShowDepartments(true)}
                    onMouseLeave={() => setShowDepartments(false)}
                    style={{
                      width: "30px",
                      textAlign: "left",
                      position: "relative",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "5px",
                    }}
                  >
                    +{props.data.allowed_dept.length - 1}
                    {showDepartments ? (
                      <div
                        style={{
                          marginTop: "0px",
                          position: "absolute",
                          left: `${ref?.current?.offsetWidth}px`,
                          cursor: "auto",
                          zIndex: "2",
                        }}
                      >
                        <MultipleDepartmentViewer
                          department={props.data.allowed_dept}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              "No Departments"
            )}
          </div>
        </TableCell>
        <TableCell
          align="right"
          className={
            props.isToggleView ? classes.listTextCustom : classes.listTextTwo
          }
          onClick={(event) => event.stopPropagation()}
        >
          <div className={classes.flexGap5}>
            {props.data?.media_folders?.media_root_id && (
              <Tooltip title="Asset Files" placement="top">
                <Button
                  size="small"
                  disabled={props.data.media_folders?.media_root_id === null}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (props.data.media_folders?.media_root_id) {
                      window.open(
                        `/${props.projectId}/project-media/${props.data.media_folders?.media_root_id}`,
                      );
                    }
                  }}
                >
                  <ReferenceFolderIcon />
                </Button>
              </Tooltip>
            )}
            <Button
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                props
                  .fetchFile(props.data.file ? props.data.id : null)
                  // opening the modal after the function has fetched file, else previous file loads first
                  .then(() => props.setIsViewModalOpen(true));
              }}
            >
              View
            </Button>
            <Tooltip title="view Task" placement="top">
              <Button
                style={{ minWidth: "25px", padding: "2px" }}
                onClick={(event) => {
                  event.stopPropagation();
                  history.push(
                    `/${props.projectId}/assets/${props.data.id}/task`,
                  );
                }}
              >
                <ArrowSquareIn height={25} width={25} />
              </Button>
            </Tooltip>
            <Tooltip title="Edit Asset" placement="top">
              <Button
                id="editAssetVersion"
                className={classes.inlineButtons}
                onClick={(e) => props.handleEditAssetModalState(e, props.data)}
              >
                <Edit3 style={{ padding: "2px" }} />
              </Button>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}

export default AssetsList;
